import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Checkbox from "../../common/checkbox/checkbox.component.jsx";
import AddressComponent from "../../customer/components/AddressComponent";
import AddressFormFields from "../../customer/components/AddressFormFieldsComponent";
import CustomerSelect from "../../customer/selection.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
import Icon from "../icon/icon.component.jsx";

const uuidv4 = require('uuid/v4')

const messages = defineMessages({
    "contact_last_name_placeholder": {
        id: 'customer.modal.placeholder.contact_last_name',
        defaultMessage: 'Enter contact last name',
    },
    "contact_first_name_placeholder": {
        id: 'customer.modal.placeholder.contact_first_name',
        defaultMessage: 'Enter contact first name',
    },
    "po_number_placeholder": {
        id: 'project.form.edit.po_number_placeholder',
        defaultMessage: 'PO number',
    },
})

class InlineEditAddress extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            endPoint: this.props.endPoint || '',
            //used to retrieve billing address
            addressEndPoint: this.props.addressEndPoint || '',
            formId: this.props.formId,
            field: this.props.field || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            isLoading: false,
            success: false,
            style: this.props.style || {},
            objectType: this.props.objectType || 'contact',
            contactId: this.props.contactId || '',
            selectedContactId: '',
            contactType: this.props.contactType || '',
            organizationId: this.props.organizationId || '',
            organizationContact: null,
            address: this.props.address || {
                addressId: '',
                street: '',
                street2: '',
                city: '',
                postalCode: '',
                stateCode: '',
                countryCode: '',
                isDefault: true,
                firstName: '',
                lastName: '',
            },
            //the address before any change in any input
            initialAddress: this.props.address || null,
            addressType: this.props.addressType || 'billing',
            sameAddressAsOrganization: this.props.sameAddressAsOrganization || false,
            contactAddresses: this.props.contactAddresses || [],
            sameAddressAsBilling: false,

        }

        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleAddressEventChange = this.handleAddressEventChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        const defaultCallback = () => { }
        this.onSave = this.props.onSave || defaultCallback
        this.handleAddressChange = this.handleAddressChange.bind(this)
    }

    componentDidMount() {
        this.loadOrganizationContact()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            endPoint: nextProps.endPoint || '',
            addressEndPoint: nextProps.addressEndPoint || '',
            field: nextProps.field || '',
            previousContactId: this.state.contactId,
            contactId: nextProps.contactId || '',
            address: nextProps.address || {
                addressId: '',
                street: '',
                street2: '',
                city: '',
                postalCode: '',
                stateCode: '',
                countryCode: '',
                isDefault: false,
                firstName: '',
                lastName: '',
            },
            style: nextProps.style || {},
            objectType: nextProps.objectType || 'contact',
            addressType: nextProps.addressType || 'billing',
            contactType: nextProps.contactType || '',
            previousOrganizationId: this.state.organizationId,
            organizationId: nextProps.organizationId || '',
            sameAddressAsOrganization: nextProps.sameAddressAsOrganization || false,
            sameAddressAsBilling: nextProps.sameAddressAsBilling || false,
        }, () => {
            if (this.state.contactId !== this.state.previousContactId) {
                this.setState({
                    initialAddress: this.state.address,
                    previousAddress: this.state.address,
                })
            }
            if (this.state.organizationId !== this.state.previousOrganizationId) {
                this.loadOrganizationContact()
            }
            this.setState({
                cachedState: {
                    address: this.state.address,
                },
            })
        })
    }

    loadBillingAddress() {
        AppContext.getApiClient().get(this.state.addressEndPoint).then(object => {
            if (object.attributes) {
                object.attributes.address.addressId = this.state.address.addressId
                if (this.state.sameAddressAsOrganization) {
                    let address = this.state.contactAddresses.find(ad => ad.addressType === this.state.addressType && ad.isDefault)
                    if (address) {
                        object.attributes.address.addressId = address.addressId
                    }
                }
                this.setState({
                    previousAddress: this.state.initialAddress,
                    address: object.attributes.address,
                    sameAddressAsOrganization: false,
                })
            }
        })
    }

    loadOrganizationContact() {
        if (this.state.organizationId) {
            AppContext.getApiClient().get(`/contacts/${this.state.organizationId}`).then((r) => {
                if (r.attributes) {
                    const contact = r.attributes
                    this.setState({
                        organizationContact: contact,
                    })
                }
            })
        }
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode,
            sameAddressAsBilling: false,
        }, () => {
            if (!this.state.editMode && this.state.cachedState) {
                this.setState({
                    address: this.state.cachedState.address,
                })
            }
        })
    }

    handleFormChange(event) {
        const name = event.target.name
        this.setState({
            [name]: event.target.value
        })
    }

    handleAddressEventChange(event) {
        const addressAttribute = event.target.name
        let address = Object.assign({}, this.state.address)
        address[addressAttribute] = event.target.value
        this.setState({
            address,
        })
    }

    handleAddressChange(change) {
        this.setState({
            address: {
                ...this.state.address,
                ...change,
            }
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({
            isLoading: true,
            cachedState: {
                address: this.state.address
            },
        })

        let form = document.getElementById(this.state.formId)
        const checkResult = form.checkValidity()
        form.classList.add('was-validated')
        if (!checkResult) {
            this.setState({
                isLoading: false,
                success: false,
            })
            return
        }

        let update = {}
        if (this.state.objectType === 'contact') {
            const sameAddressTypeAttribute = this.state.addressType === 'billing' ? 'sameBillingAddressAsOrganization' : 'sameShippingAddressAsOrganization'
            update[sameAddressTypeAttribute] = this.state.sameAddressAsOrganization
        }
        if (!this.state.sameAddressAsOrganization || this.state.objectType === 'project') {
            let address = Object.assign({}, this.state.address)
            address.addressType = this.state.addressType
            update[this.state.field] = address
        }
        if (this.state.endPoint && this.state.field) {
            AppContext.getApiClient().patch(this.state.endPoint, update).then((r) => {
                this.setState({
                    success: !r.error,
                    isLoading: false,
                    editMode: !!r.error,
                }, () => {
                    form.classList.remove('was-validated')

                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1500)
                })
                this.onSave(this.state)
            })
        }
    }

    setAddressToOriginalPersonAddress() {
        let address = this.state.contactAddresses.find(ad => ad.addressType === this.state.addressType && ad.isDefault)
        if (address) {
            this.setState({
                address: {
                    addressId: address.addressId,
                    street: address.street,
                    street2: address.street2,
                    city: address.city,
                    postalCode: address.postalCode,
                    stateCode: address.stateCode,
                    countryCode: address.countryCode,
                    isDefault: true,
                    firstName: address.firstName,
                    lastName: address.lastName,
                }
            })
        }
    }

    getCustomerSelectFilters() {
        let filters = {}
        if (this.state.contactType === 'organizations') {
            filters.organizationId = this.state.contactId
        } else if (this.state.contactType === 'persons') {
            filters.organizationId = this.state.organizationId
        }
        return filters
    }

    renderShipToForm() {
        const forms = []

        forms.push(<div key={forms.length} className={"form-group row d-flex justify-content-center " +
            (this.state.contactType === 'persons' || this.state.contactType === 'suppliers' && this.state.addressType === 'billing' 
                ? "mb-0" : "bg-light pb-3")}>
            <div className={"col-12"}>
                <div className={"row"}>
                    <label className={"col-12 col-form-label custom-form-label"} htmlFor="personId">
                        {this.state.contactType === 'organizations' &&
                            <FormattedMessage
                                id="customer.modal.add_form.select_employee_address_label"
                                defaultMessage="Select an employee address (optional)"
                            />
                        }
                    </label>
                    <div className="col-12">
                        {(!this.state.contactType || this.state.contactType === 'organizations') &&
                            <CustomerSelect
                                value={this.state.selectedContactId}
                                onChange={(contactId) => {
                                    if (contactId) {
                                        AppContext.getApiClient().get(`/contacts/${contactId}`).then((r) => {
                                            if (!r.attributes) {
                                                return
                                            }

                                            const contact = r.attributes
                                            if (r.type === 'organizations') {
                                                contact.address.firstName = contact.name
                                                contact.shippingAddress.firstName = contact.name
                                            }
                                            let newAddress = this.state.addressType === 'billing' ? contact.address : contact.shippingAddress
                                            newAddress.addressId = this.state.address.addressId
                                            this.setState({
                                                selectedContactId: contactId,
                                                previousAddress: this.state.address,
                                                address: newAddress,
                                                sameAddressAsBilling: false,
                                            })
                                        })
                                    } else {
                                        this.setState({
                                            address: this.state.initialAddress,
                                            selectedContactId: '',
                                        })
                                    }
                                }}
                                contactType={'persons'}
                                allowCreate={false}
                                addressType={this.state.addressType}
                                showAddressInLabel={true}
                                filters={this.getCustomerSelectFilters()}
                            />
                        }
                        {this.state.contactType === 'persons' && this.state.organizationId !== '' &&
                            <div className="row mb-0">
                                <div className="col-12 d-flex">
                                    <div className={'mr-4'}>
                                        <Checkbox id={'sameAddressAsOrganization'}
                                            checked={this.state.sameAddressAsOrganization} onChange={(isChecked) => {
                                                this.setState({
                                                    sameAddressAsOrganization: isChecked,
                                                    selectedContactId: '',
                                                }, () => {
                                                    if (this.state.sameAddressAsOrganization && this.state.organizationContact) {
                                                        this.setState({
                                                            address: this.state.addressType === 'billing' ? this.state.organizationContact.address : this.state.organizationContact.shippingAddress,
                                                            sameAddressAsBilling: false,
                                                        })
                                                    } else if (!this.state.sameAddressAsOrganization) {
                                                        this.setAddressToOriginalPersonAddress()
                                                    }
                                                })
                                            }} className={'mr-2'} />
                                        <label htmlFor={'sameAddressAsOrganization'}>
                                            <FormattedMessage
                                                id="customer.modal.add_form.same_address_as_organization_label"
                                                defaultMessage="Same address as this contact's organization"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }

                        {this.state.addressType === 'shipping' &&
                            <div className={'row mb-0 ' + (this.state.contactType === 'persons' ? '' : 'mt-2')}>
                                <div className="col-12 d-flex">
                                    <div className={'mr-4'}>
                                        <Checkbox id={'sameAddressAsBilling'} checked={this.state.sameAddressAsBilling}
                                            onChange={(isChecked) => {
                                                this.setState({
                                                    sameAddressAsBilling: isChecked,
                                                    selectedContactId: '',
                                                }, () => {
                                                    if (this.state.sameAddressAsBilling) {
                                                        this.loadBillingAddress()
                                                    } else {
                                                        this.setState({
                                                            previousAddress: null,
                                                            address: this.state.previousAddress || this.state.initialAddress,
                                                        })
                                                    }
                                                })
                                            }} className={'mr-2'} />
                                        <label htmlFor={'sameAddressAsBilling'}>
                                            <FormattedMessage
                                                id="customer.modal.add_form.same_address_as_billing_label"
                                                defaultMessage="Same address as billing address"
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </div>
        </div>)
        if (this.state.contactType === 'organizations' || this.state.contactType === 'suppliers' && this.state.addressType === 'shipping') {
            forms.push(<hr />)
        }
        forms.push(<div key={forms.length} className="form-group row mb-2">
            <div className={"col-12 col-lg-6"}>
                <div className={"row"}>
                    <label className={"col-12 col-form-label custom-form-label"} htmlFor="firstName">
                        <FormattedMessage
                            id="customer.modal.add_form.contact_first_name_label"
                            defaultMessage="First Name"
                        />
                    </label>
                    <div className="col-12">
                        <input
                            type="text"
                            className="form-control"
                            id="firstName"
                            name="firstName"
                            value={this.state.address.firstName}
                            placeholder={this.props.intl.formatMessage(messages["contact_first_name_placeholder"])}
                            onChange={this.handleAddressEventChange}
                            disabled={this.state.sameAddressAsOrganization}
                        />
                    </div>
                </div>
            </div>
            <div className={"col-12 col-lg-6"}>
                <div className={"row"}>
                    <label className={"col-12 col-form-label custom-form-label"} htmlFor="lastName">
                        <FormattedMessage
                            id="project.ship_form.contact_last_name_label"
                            defaultMessage="Last Name"
                        />
                    </label>
                    <div className="col-12">
                        <input
                            type="text"
                            className="form-control"
                            id="lastName"
                            name="lastName"
                            value={this.state.address.lastName}
                            placeholder={this.props.intl.formatMessage(messages["contact_last_name_placeholder"])}
                            onChange={this.handleAddressEventChange}
                            disabled={this.state.sameAddressAsOrganization}
                            required />
                        <div className="invalid-feedback">
                            <FormattedMessage
                                id="customer.modal.add_form.contact_last_name_field_error"
                                defaultMessage="Contact last name is required"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>)
        return <div className={"row mb-3"}>
            <div className={"col-12"}>
                {forms}
            </div>
        </div>
    }


    render() {
        let text = (
            <>
                <div>{this.state.address.firstName} {this.state.address.lastName}</div>
                <AddressComponent value={this.state.address} />
            </>
        )

        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler}
                onMouseLeave={this.onMouseLeaveHandler}>
                {text}
                {!this.state.success ?
                    <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
                    <Icon value={'check'}
                        className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />
                }
            </a>
            text = <span style={{ pointerEvents: this.state.isLoading ? 'none' : '' }} onClick={e => e.preventDefault()}>
                {link}
                <div className={"dropdown-menu px-4 pb-4 " + (this.state.editMode ? 'show' : '')}
                    style={Object.assign({ width: '600px', zIndex: '9999' }, this.state.style)}>
                    <form className="needs-validation" id={this.state.formId} noValidate>
                        <div className="w-100 m-0">
                            {this.renderShipToForm()}
                            <div className="form-group">
                                <AddressFormFields
                                    value={this.state.address}
                                    onChange={this.handleAddressChange} />
                            </div>
                        </div>
                        <p className="m-0 pt-2">
                            <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}
                                style={{ pointerEvents: 'auto' }}>
                                <Icon value={"arrow-left"} />
                            </button>
                            <ActionButton
                                className="btn btn-sm btn-outline-primary ml-2"
                                onClick={this.save}
                                type={'submit'}
                                isLoading={this.state.isLoading}
                                disabled={this.state.lastName === ''}>
                                <Icon value={"save"} />
                            </ActionButton>
                        </p>
                    </form>
                </div>
            </span>
        }

        return text
    }

}

export default injectIntl(InlineEditAddress)





// WEBPACK FOOTER //
// ./src/common/inline-edit/address.component.jsx